import { createAction, props } from '@ngrx/store';
import { MenuItem } from '@core/models';

export const PRODUCT_FIND = createAction('[Product] Find', props<{ productName?: string, suggestionItems?: string[], subcategoryId?: string }>());
export const PRODUCT_FIND_SUCCESS = createAction('[Product] Find Success', props<{ productList: MenuItem[] }>());
export const PRODUCT_FAILED = createAction('[Product] Failed', props<{ error: string }>());
export const PRODUCT_UPDATE_LOADING = createAction('[Product] Update Loading', props<{ loading: boolean }>());

export const PRODUCT_UPDATE_ID = createAction('[Product] Update id', props<{ idArticulo: string }>());

export const PRODUCT_UPDATE_STOCK = createAction('[Product] Update Stock', props<{ id: string, cantidad: number, operation: 'INCREMENTO' | 'DECREMENTO' }>());

export const PRODUCT_ALL_UPDATE_STOCK = createAction('[Product] All Update Stock');

export const SUGGESTION_ITEMS_FIND = createAction('[Product] Suggestion Items Find', props<{ ids: string[] }>());
export const SUGGESTION_ITEMS_FIND_SUCCESS = createAction('[Product] Suggestion Items Find Success', props<{ suggestionItems: MenuItem[] }>());

export const SUGGESTION_ITEMS_FIND_RESET = createAction('[Product] Suggestion Items Reset');